import classnames from 'classnames';
import Button, { ButtonVariants } from '../../../components/Button';
import AnimatedTitle from '../../../components/AnimatedTitle';
import styles from './Article.module.scss';

type SeeMoreArticleCTAProps = {
  text: string;
  linkText: string;
  link: string;
};
const SeeMoreArticleCTA = ({
  text, linkText, link,
}: SeeMoreArticleCTAProps) => (
  <div
    className={styles.seeMoreArticleCTAContainer}
  >
    <p className={styles.seeMoreArticleCTASubtitle}>See more</p>
    <h5 className={classnames('sectionTitle', styles.seeMoreArticleCTATitle)}>
      <AnimatedTitle title={text} />
    </h5>
    <Button
      variant={ButtonVariants.LINK}
      link={link}
    >
      {linkText}
    </Button>
    <div className={styles.seeMoreArticleCTAEllipse} />
  </div>
);

export default SeeMoreArticleCTA;
